/**
 * Custom Product Grid (homepage Best Sellers / New Arrivals):
 * - Show "FITS YOUR TRUCK" only when a garage vehicle is selected and the product fits.
 * - Reorder cards: fitting products first (stable), then the rest in original order.
 */
(function () {
  if (window.__fcdCpsFitmentInit) return;
  window.__fcdCpsFitmentInit = true;

  var GRID_SEL = '[data-cps-fitment-grid]';
  var CARD_SEL = '[data-cps-product-card]';
  var BADGE_SEL = '[data-cps-fit-badge]';
  var FIT_VALUES = { yes: true, universal: true, aggressive: true };
  var runToken = 0;

  function cm() {
    return window.Convermax || null;
  }

  function isVehicleSelected() {
    var api = cm();
    if (!api) return false;
    if (typeof api.isVehicleSelected === 'function') {
      try {
        return !!api.isVehicleSelected();
      } catch (e) {
        /* fall through */
      }
    }
    if (typeof api.getVehicleString === 'function') {
      try {
        return String(api.getVehicleString() || '').trim().length > 0;
      } catch (e) {
        return false;
      }
    }
    return false;
  }

  function getVehicle() {
    var api = cm();
    if (!api || typeof api.getVehicle !== 'function') return null;
    try {
      return api.getVehicle() || null;
    } catch (e) {
      return null;
    }
  }

  function grids() {
    return Array.prototype.slice.call(document.querySelectorAll(GRID_SEL));
  }

  function cardsIn(grid) {
    return Array.prototype.slice.call(grid.querySelectorAll(CARD_SEL));
  }

  function setBadgeVisible(card, visible) {
    var badge = card.querySelector(BADGE_SEL);
    if (!badge) return;
    if (visible) {
      badge.hidden = false;
      badge.removeAttribute('hidden');
    } else {
      badge.hidden = true;
      badge.setAttribute('hidden', '');
    }
  }

  function restoreOrder(grid) {
    var list = cardsIn(grid).slice().sort(function (a, b) {
      return Number(a.dataset.cpsIndex || 0) - Number(b.dataset.cpsIndex || 0);
    });
    list.forEach(function (card) {
      card.dataset.cpsFits = '';
      setBadgeVisible(card, false);
      grid.appendChild(card);
    });
  }

  function reorderFitFirst(grid) {
    var list = cardsIn(grid);
    var fits = [];
    var rest = [];
    list.forEach(function (card) {
      if (card.dataset.cpsFits === '1') fits.push(card);
      else rest.push(card);
    });
    fits.concat(rest).forEach(function (card) {
      grid.appendChild(card);
    });
  }

  function verifyProduct(productId, vehicle) {
    var api = cm();
    if (!api || typeof api.verifyFitmentAsync !== 'function') {
      return Promise.resolve('');
    }
    return api
      .verifyFitmentAsync(String(productId), vehicle)
      .then(function (result) {
        return String(result || '').toLowerCase();
      })
      .catch(function () {
        return '';
      });
  }

  function syncGrid(grid, vehicle, token) {
    var list = cardsIn(grid);
    if (!list.length) return Promise.resolve();

    return Promise.all(
      list.map(function (card) {
        var productId = card.getAttribute('data-product-id');
        if (!productId) {
          card.dataset.cpsFits = '';
          setBadgeVisible(card, false);
          return Promise.resolve();
        }
        return verifyProduct(productId, vehicle).then(function (result) {
          if (token !== runToken) return;
          var fits = !!FIT_VALUES[result];
          card.dataset.cpsFits = fits ? '1' : '0';
          setBadgeVisible(card, fits);
        });
      })
    ).then(function () {
      if (token !== runToken) return;
      reorderFitFirst(grid);
    });
  }

  function syncAll() {
    var token = ++runToken;
    var selected = isVehicleSelected();
    var vehicle = selected ? getVehicle() : null;
    var all = grids();

    if (!selected || !vehicle) {
      all.forEach(restoreOrder);
      return Promise.resolve();
    }

    return Promise.all(
      all.map(function (grid) {
        return syncGrid(grid, vehicle, token);
      })
    );
  }

  function chainHook(name, handler) {
    window.Convermax = window.Convermax || {};
    var prev = window.Convermax[name];
    window.Convermax[name] = function () {
      var args = arguments;
      try {
        if (typeof prev === 'function') prev.apply(window.Convermax, args);
      } catch (e) {
        /* keep going */
      }
      handler.apply(null, args);
    };
  }

  function start() {
    if (!grids().length) return;

    syncAll();

    chainHook('onVehicleSelected', function () {
      syncAll();
    });
    chainHook('onVehicleRemoved', function () {
      syncAll();
    });

    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      if (cm() && (typeof cm().verifyFitmentAsync === 'function' || tries > 8)) {
        syncAll();
      }
      if (tries > 40) window.clearInterval(timer);
    }, 250);

    document.addEventListener('cm:ready', syncAll);
    document.addEventListener('convermax:ready', syncAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
